/**
 * Template: Collection
 * -----------------------------------------------------------------------------
 * Used to import styles and components for all collection templates.
 *
 */

import variantGridItem from '~/components/variant-grid-item'

document.addEventListener('DOMContentLoaded', () => {
  variantGridItem().init()
})
